import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            display: 'flex',
            flexDir: 'row',
            alignItems: 'center',
            maxHeight: 'none',
            padding: remCalc(2),
            borderRadius: 'large',
            bg: 'background.neutral.default',
            boxShadow:
                '0 0 0 1px var(--chakra-colors-border-neutral-highlight) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs) !important',
            color: 'foreground.neutral.default',
            border: 'none',
        },
        input: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            width: remCalc(36),
            height: remCalc(36),
            textStyle: 'body-small',
            fontWeight: 'medium',
            border: 0,
        },
        incAndDecButton: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            borderRadius: 'medium',
            color: 'foreground.neutral.default',
            width: remCalc(36),
            height: remCalc(36),
            minWidth: 'auto',
            padding: remCalc(10),

            _hover: {
                bg: 'background.neutral.hover',
            },
            _disabled: {
                bg: 'background.neutral.default',
                color: 'foreground.neutral.muted',
                cursor: 'not-allowed',
            },
        },
    },
    variants: {},
}
